import React from "react";
import { useTranslation } from "react-i18next";
import TopMenu from "../../components/TopMenu/TopMenu";
import BottomNav from "../../components/BottomNav/BottomNav";
import Table, { TableColumn } from "../../components/Table/Table";
import FacilitatorCell from "../../components/FacilitatorCell/FacilitatorCell";
import useMeusHorarios from "./useMeusHorarios";
import { MyShift } from "../../models/Plantao";
import "./MeusHorarios.css";

type MeuHorarioRow = {
  id: string;
  place: string;
  dateRange: string;
  role: string;
  link?: string;
  isOnline: boolean;
  facilitator: MyShift["facilitator"];
};

export default function MeusHorarios() {
  const { horarios, isLoading, error, reload } = useMeusHorarios();
  const { t } = useTranslation();

  const columns: TableColumn<MeuHorarioRow>[] = [
    {
      id: "place",
      header: t("pages.meusHorarios.local"),
      render: (item) => item.isOnline ? t("online") : item.place
    },
    {
      id: "dateRange",
      header: t("pages.meusHorarios.dataHorario"),
      render: (item) => item.dateRange
    },
    {
      id: "role",
      header: t("pages.meusHorarios.funcao"),
      render: (item) => item.role
    },
    {
      id: "link",
      header: t("pages.meusHorarios.linkOnline"),
      render: (item) =>
        item.link ? (
          <a href={item.link} rel="noreferrer" target="_blank">
            {item.link}
          </a>
        ) : (
          ""
        )
    },
    {
      id: "facilitator",
      header: t("pages.meusHorarios.facilitador"),
      render: (item) => <FacilitatorCell facilitator={item.facilitator} />
    }
  ];

  return (
    <div className="meus-horarios-page">
      <TopMenu />

      <main className="meus-horarios-content">
        <section className="meus-horarios-hero">
          <p className="meus-horarios-hero-title">{t("pages.meusHorarios.title")}</p>
        </section>

        {isLoading ? (
          <div className="meus-horarios-state">Carregando horarios...</div>
        ) : error ? (
          <div className="meus-horarios-state meus-horarios-state-error">
            <p>{error}</p>
            <button
              className="meus-horarios-retry"
              type="button"
              onClick={() => {
                reload().catch((requestError) => {
                  console.error("Erro ao recarregar horarios:", requestError);
                });
              }}
            >
              Tentar novamente
            </button>
          </div>
        ) : horarios.length === 0 ? (
          <div className="meus-horarios-state">Nenhum horario encontrado.</div>
        ) : (
          <Table<MeuHorarioRow>
            beforeHeader={
              <div className="meus-horarios-row meus-horarios-section">
                <div className="table-cell">{t("pages.meusHorarios.proximosPlantoes")}</div>
              </div>
            }
            bodyRowClassName="meus-horarios-row"
            columns={columns}
            data={horarios}
            getRowKey={(item) => item.id}
            gridTemplateColumns="minmax(100px, 1fr) minmax(200px, 2fr) minmax(200px, 2fr) minmax(120px, 1fr) minmax(150px, 1.5fr) minmax(150px, 1.5fr)"
            headerRowClassName="meus-horarios-row meus-horarios-header"
            stickyHeaderTop={54}
            wrapperClassName="meus-horarios-table-wrapper"
          />
        )}
      </main>

      <BottomNav />
    </div>
  );
}
